import { Box } from "@mui/material"
import HeroSectionComponent from "./hero-section.component";
import ScrollReveal from "../animations/ScrollReveal";
import CompetitiveAdvantageSectionComponent from "./competitive-advantage-section.component";
import StrategicGoalsSectionComponent from "./strategic-goals-section.component";
import CoreValuesSectionComponent from "./core-values-section.component";
import OfferingSectionComponent from "./offering-section.component";
import PartnersSectionComponent from "./partners-section.component";
import FooterComponent from "../../layout/footer.component";

const ContentSectionComponent = () => {

    return (

        <Box>
            <Box id="about">
                <HeroSectionComponent />
            </Box>
            <ScrollReveal direction="left">
                <Box id="competitive-advantage">
                    <CompetitiveAdvantageSectionComponent />
                </Box>
            </ScrollReveal>
            <ScrollReveal direction="right">
                <Box id="strategic-goals">
                    <StrategicGoalsSectionComponent />
                </Box>
            </ScrollReveal>
            <ScrollReveal direction="up">
                <Box id="core-values">
                    <CoreValuesSectionComponent />
                </Box>
            </ScrollReveal>
            <ScrollReveal direction="up" delay={0.2}>
                <OfferingSectionComponent />
            </ScrollReveal>
            <ScrollReveal direction="up">
                <Box id="partners">
                    <PartnersSectionComponent />
                </Box>
            </ScrollReveal>
        </Box>

    )
}

export default ContentSectionComponent
